import React,{useState,useEffect,lazy} from 'react';
import axios from 'axios'
import {  Slider,Statistic,Tabs,Modal,Image } from 'antd';
import { ArrowUpOutlined,MinusCircleFilled,ToolOutlined, ArrowDownOutlined,FileFilled,WalletFilled,SearchOutlined,FundViewOutlined,
   UserOutlined, AccountBookOutlined,CalculatorFilled,SwapOutlined,GroupOutlined,AccountBookFilled, DollarCircleOutlined,EditFilled,MessageFilled,DollarOutlined,CarFilled,LoadingOutlined,PlusCircleFilled } from '@ant-design/icons';
import moment from 'moment';
import { Line,Pie,Bar } from 'react-chartjs-2';
import {withGetScreen} from 'react-getscreen'
import { Tooltip,Popover,Table,Popconfirm,Input, Button,Collapse,Card,Avatar,Form,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Spin } from 'antd';
import {
  Col,
  Row,
} from 'reactstrap';
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'
import * as serverconfig from '../serverconn'
import * as serversocketconfig from '../serversocketconfig'
import { MdShoppingCart } from 'react-icons/md';

import CurrencyFormat from 'react-currency-format';
import Highlighter from 'react-highlight-words';
import Websocket from 'react-websocket';
import { Link } from 'react-router-dom';
import ReconnectingWebSocket from 'reconnecting-websocket';
import { NavLink } from 'react-router-dom'
import * as primarycolor from '../primarycolor'
import logo from '../../assets/logo.png';


var CryptoJS = require("crypto-js");

const { TextArea } = Input;
const antIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;

const style = { background: '#0092ff', padding: '8px 0',borderRadius: '7px',justifyContent:'center', alignItems:'center',display: 'flex', };
const dateFormat = 'DD/MM/YYYY';
const yeardateFormat = 'YYYY';
const monthdateFormat = 'MM/YYYY';

const { Meta } = Card;
const { Panel } = Collapse;
const { TabPane } = Tabs;
const FormItem=Form.Item;
const { Option } = Select;


class Portal_Registration extends React.Component {

 
  componentDidMount(){
 
    
  }



render() {
      return(
          <div >
                 <h3>I currently hold licences</h3>
                  <ol>
                  <li>Applications for existing licence and applications to register for access to the Mining Cadastre Portal must be presented in person by the individual who wishes to use the portal. The application must consist of:<ol>
                  <li>A completed registration form</li>
                  <li>Proof of identity</li>
                  <li>If an employee or agent, an original Letter of Authority signed by a company director authorising the individual to act on behalf of the company or person.</li>
                  </ol></li>
                  <li>Once the Directorate of Geological Survey and Mines has processed the application, a user profile will be created in the Mining Cadastre Portal and an email sent to the user's registered email address with a link to set a password for the first time.</li>
                  </ol>
                  <p><a href={serverconfig.backendserverurl+`/customqueries/serve-file/1`} >Download Registration form</a></p>
                  <p>&nbsp;</p>
                  <h3>&nbsp;Terms of Use Summary</h3>
                  <p >This Mining Cadastre Portal is provided as a public service by the&nbsp;Directorate of Geological Survey and Mines of the Republic of Uganda.</p>
                  <p >By accessing this system you hereby agree to the Terms and&nbsp;Conditions of the Mining Cadastre Portal.</p>
                  <p >Access to this Mining Cadastre Portal&nbsp;by any person other than an&nbsp;authorized individual&nbsp;or an authorized&nbsp;agent for a company is strictly prohibited and may result in legal action against such person.</p>
                  <p >The Mining Cadastre Portal and all of the information it contains are provided "as is" without warranty of any kind, whether express or implied. All implied warranties, including, without limitation, implied warranties of merchantability, fitness for a particular purpose, and non-infringement, are hereby expressly disclaimed.</p>
                  <p >Under no circumstances will the Ugandan&nbsp;Directorate of Geological Survey and Mines or any of its Suppliers be liable to any person or business entity for any direct, indirect, special, incidental, consequential, or other damages based on any use of the Mining Cadastre Portal or any other website to which this site is linked, including, without limitation, any lost profits, business interruption, or loss of programs or information, even if the&nbsp;Ugandan&nbsp;Directorate of Geological Survey and Mines or any of its Suppliers has been specifically advised of the possibility of such damages.</p>
                  <p >&nbsp;</p>

          </div>
      )
}
}

export default Portal_Registration; 
